var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"download"},[_c('span',{staticClass:"download__text"},[_vm._v("\n        "+_vm._s(_vm.$t('DOWNLOAD_ON_THE'))+"\n    ")]),_c('img',{staticClass:"download__img",attrs:{"src":require(`@/assets/appstore-download-${_vm.theme}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }